import '.k{display:grid;}.ssr-plugin'
import '.l{grid-template-columns:minmax(0, 1fr);}.ssr-plugin'
import '.i{gap:1.5rem;}.ssr-plugin'
import '.h{text-align:center;}.ssr-plugin'
import '.m{color:var(--gray-500);}.ssr-plugin'
import '.n{padding:2rem;}.ssr-plugin'
import { BlogCard } from '@app/components/blocks/card/BlogCard'
import { useCallback, useEffect, useState } from 'react'
import { useClient, useLoading, useQuery } from '@based/sdk/react'
import { KnowledgeHubModule } from '@schema/knowledgeHubModule'
import { useLocation } from 'wouter'
import { pages } from '@app/util/links'
import { styled } from 'inlines'
import { useTranslations } from '@i18n/useLanguage'
import { SearchField } from '@app/components/blocks/searchBar/SearchField'
import Column from '@app/components/layout/Column'
import { PageLayout } from '../layout/PageLayout'
import { Title } from '@app/components/core/typography/Title'

export const KnowledgeHub = () => {
  const t = useTranslations().app.knowledgeHubPage
  return (
    <PageLayout>
      <Title.H1 style={{ textAlign: 'center' }}>{t.title}</Title.H1>
      <KnowledgeHubItemsList />
    </PageLayout>
  )
}

export const KnowledgeHubItemsList = () => {
  const t = useTranslations().app.knowledgeHubPage
  const [, setLocation] = useLocation()
  const [searchBarInput, setSearchBarInput] = useState('')
  const [searchTerm, setSearchTerm] = useState('')
  const [clientModules, setClientModules] = useState<KnowledgeHubModule[]>([])
  const [mounted, setMounted] = useState(false)
  const client = useClient()
  const isLoading = useLoading()

  const serverQuery = useQuery('list-knowledge-hub-module', {
    searchTerm: searchTerm || undefined,
  })
  const serverModules: KnowledgeHubModule[] = serverQuery.data ?? []

  const subscribeList = useCallback(() => {
    const close = client
      .query('list-knowledge-hub-module', {
        searchTerm: searchTerm || undefined,
      })
      .subscribe((result) => {
        setClientModules(result ?? [])
        setMounted(true)
      })
    return () => close()
  }, [client, searchTerm])

  useEffect(() => {
    setMounted(false)
    const cleanup = subscribeList()
    return cleanup
  }, [subscribeList])

  const modules: KnowledgeHubModule[] = mounted ? clientModules : serverModules

  const showLoading = isLoading || !mounted

  return (
    <Column gap="1.5rem" alignItems="stretch">
      <SearchField
        placeholder={t.searchPlaceholder}
        searchBarInput={searchBarInput}
        searchTerm={searchTerm}
        setSearchBarInput={setSearchBarInput}
        setSearchTerm={setSearchTerm}
      />
      {showLoading ? (
        <styled.div>{t.loading}</styled.div>
      ) : (
        <>
          <styled.div className="k l i"
            style={{
              '@media (min-width: 800px)': {
                gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                '& > :nth-child(1)': {
                  gridColumn: 'span 2',
                },
              },
            }}
          >
            {modules.map((item: KnowledgeHubModule) => (
              <BlogCard
                key={item.id}
                title={item.title}
                image={item.images?.[0]?.src}
                onClick={() => setLocation(pages.knowledgeHubModule(item.slug))}
              />
            ))}
          </styled.div>

          {modules.length === 0 && searchTerm && (
            <p className="h m n"
            >
              {t.noResults}
            </p>
          )}
        </>
      )}
    </Column>
  )
}
